export default {"src":"/_next/static/media/retail-icon.353c7ac7.svg","height":75,"width":115,"blurWidth":0,"blurHeight":0};